// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"ef8c4c0f","937":"1934e461"}[chunkId] + ".chunk.js";
};